"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1525))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.545Z
 */
export const Diamond = createSVGIcon(
  <>
    <path
      d="M17.9742 3.02149H6.0256C5.75262 3.02146 5.48358 3.08662 5.24086 3.21156C4.99815 3.3365 4.78878 3.51759 4.63017 3.73977L1.64217 7.92263C1.41814 8.23588 1.30611 8.61545 1.32415 9.00016C1.34219 9.38486 1.48924 9.75228 1.7416 10.0432L10.7039 20.3838C10.8648 20.5696 11.0638 20.7187 11.2874 20.8209C11.5111 20.9231 11.754 20.9759 11.9999 20.9759C12.2457 20.9759 12.4887 20.9231 12.7123 20.8209C12.9359 20.7187 13.135 20.5696 13.2959 20.3838L22.2582 10.0432C22.5105 9.75228 22.6576 9.38486 22.6756 9.00016C22.6937 8.61545 22.5816 8.23588 22.3576 7.92263L19.3713 3.73977C19.2125 3.51735 19.0029 3.33612 18.7599 3.21117C18.5168 3.08622 18.2474 3.02119 17.9742 3.02149Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.143 3.02148L7.14355 9.22206L12.0001 20.9769"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8966 3.02148L16.896 9.22206L12 20.9769"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.35059 9.22461H22.6489"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Diamond",
  { viewBox: "0 0 24 24", fill: "none", color: Core.icon.default } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
